module.exports = __webpack_public_path__ + "media/images/img-mirror-eb6e744b5d4147d999b53cc1af31bb2c.svg";